module.exports = __webpack_public_path__ + "static/media/Etel-orb.ff6d1b17.jpg";